import { render, staticRenderFns } from "./scrollBack.vue?vue&type=template&id=ce1c38bc&"
import script from "./scrollBack.vue?vue&type=script&lang=js&"
export * from "./scrollBack.vue?vue&type=script&lang=js&"
import style0 from "./scrollBack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports